import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const ConfirmationModal = ({ show, close, onClick, message, btns: { leftBtn, rightBtn } }) => {
  return (
    <Modal
      show={show}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="customConfirmBox"
    >
      <Modal.Body>
        <div className="custom-container">
          <h6 className="titile">Confirmation</h6>
          <label className="description mt-3">{message}</label>
          <div className="center-block text-right mt-2 links">
            <button className="btn btn-ghost btn-small revertBtn mr-3 cancel" onClick={close}>
              {leftBtn}
            </button>
            <button className="btn btn-primary btn-small proceedBtn regenerate" onClick={onClick}>
              {rightBtn}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  btns: PropTypes.object.isRequired,
};

export default ConfirmationModal;
